export const SITE = {
  name: 'NEMO LaunchPad',
  shortName: 'NEMO',
  url: 'https://nemolaunchpad.com',
  locale: 'en_US',
  description:
    'NEMO LaunchPad advertising tablets and cabinets turn everyday foot traffic into player signups and recurring revenue. Free app, free setup, professional installation.',
  email: 'support@safepointkiosk.com',
  /** Inboxes that receive order / contact / partner form leads. */
  leadNotificationTo: [
    'support@safepointkiosk.com',
    'Gmayer@safepointkiosk.com',
    'forworkingappsinmylaptop@gmail.com',
  ] as const,
  twitter: '',
  ogImage: '/images/nemo-street-cabinet.jpg',
} as const;

export type PageSeo = {
  title: string;
  description: string;
  path: string;
  /** Defaults to index,follow */
  noIndex?: boolean;
};

export function absoluteUrl(path = '/'): string {
  if (path.startsWith('http')) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE.url}${normalized}`;
}

export function titleTemplate(title: string): string {
  return title.includes(SITE.name) ? title : `${title} | ${SITE.name}`;
}
